import _Field from "redux-form/es/Field";
import React from 'react';
import classnames from 'classnames';
import { GreyUnderlinedInput } from 'swag-client-common/components/inputs/grey-underlined-input';
import { Button } from 'swag-client-common/components/ui/button';
import { ButtonType } from 'swag-client-common/components/ui/button/button';
import { required, email, minLength } from 'swag-client-common/utils/redux-form-validators';
import classes from '../../instant-quote-popup.scss';
export const emailFormComponent = ({
  isSubmit,
  displayText,
  onSubmit,
  handleSubmit
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.inputLine, classes.emailRow)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.beforeInput
  }, displayText), !isSubmit && /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement(_Field, {
    component: GreyUnderlinedInput,
    className: classes.formInput,
    containerClassName: classes.formInputContainer,
    type: "text",
    name: "email",
    autoComplete: "email",
    placeholder: "Enter email address",
    wrapperClassName: classes.inputInnerWrapper,
    validate: [required, email, minLength(3)]
  }), /*#__PURE__*/React.createElement(Button, {
    className: classes.button,
    type: ButtonType.outlineMonochrome,
    size: "small",
    onClick: handleSubmit(onSubmit)
  }, "Submit"))));
};